module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "aio-media"
    }
  }, [_c('mu-card', {
    staticClass: "aio-input"
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('mu-icon', {
    staticClass: "card-left-icon blueIcon",
    attrs: {
      "value": "photo_camera",
      "size": 20
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardPhotos'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": _vm.isOpenInput ? 'remove_circle_outline' : 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpenInput),
      expression: "isOpenInput"
    }]
  }, [_c('div', {
    class: {
      bottom: _vm.images.length > 0 || _vm.isUploadingImage
    },
    attrs: {
      "id": "uploadImage"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "labelClass": "large",
      "id": "uploadBtn",
      "label": _vm.$t('message.cardPhotosChoosePicture'),
      "disabled": _vm.isUploadingImage,
      "primary": ""
    },
    on: {
      "click": _vm.bindUploadEvent
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.chooseImage
    }
  })], 1), _vm._v(" "), (_vm.images.length > 0 || _vm.isUploadingImage) ? _c('div', {
    staticClass: "label bottom"
  }, [_c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardPhotosAddingPhotos'))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isUploadingImage) ? _c('div', {
    staticClass: "loader"
  }, [_c('mu-circular-progress', {
    staticClass: "uploadProgress",
    staticStyle: {
      "position": "relative",
      "left": "2px"
    },
    attrs: {
      "mode": "determinate",
      "size": 20,
      "value": _vm.uploadProgress
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.images), function(image, index) {
    return _c('mu-avatar', {
      key: 'image-' + index,
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "src": image.image_url,
        "imgClass": "progPic"
      }
    })
  }), _vm._v(" "), (_vm.profileImage) ? _c('avatar-uploader', {
    attrs: {
      "hideAvatar": true,
      "imageUrl": _vm.profileImage
    }
  }) : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-745de840","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddProgress/aio-components/Picture/Pictures.vue
// module id = 3782
// module chunks = 1